import React, { useLayoutEffect, useRef } from "react";
import LogoBlack from "../frontend/assets/diakonhjemmet_logo.svg";
import LogoWhite from "../frontend/assets/logo-negative.svg";

interface HageHeaderProps {
    homeUrl: string;
    logoVariant?: "black" | "white";
    menuOpen: boolean;
    onMenuToggle: () => void;
}

const HamburgerIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
        <line x1="3" y1="6" x2="21" y2="6" />
        <line x1="3" y1="12" x2="21" y2="12" />
        <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
);

const CloseIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
);

const HageHeader: React.FC<HageHeaderProps> = ({
    homeUrl,
    logoVariant = "black",
    menuOpen,
    onMenuToggle,
}) => {
    const headerRef = useRef<HTMLElement>(null);

    useLayoutEffect(() => {
        if (typeof window === "undefined" || !headerRef.current) return;
        const el = headerRef.current;
        const update = () => {
            document.documentElement.style.setProperty(
                "--hage-header-height",
                `${el.getBoundingClientRect().height}px`,
            );
        };
        update();
        const ro = new ResizeObserver(update);
        ro.observe(el);
        return () => ro.disconnect();
    }, []);

    useLayoutEffect(() => {
        const offset = menuOpen
            ? window.innerWidth - document.body.getBoundingClientRect().width
            : 0;
        document.body.style.marginRight = offset ? `${offset}px` : "";
        document.body.classList.toggle("hage-menu-open", menuOpen);
    }, [menuOpen]);

    return (
        <header ref={headerRef} className="hage-header">
            <div className="container">
                <div className="hage-header__inner">
                    <a href={homeUrl} className="hage-header__logo" aria-label="Forside">
                        {logoVariant === "white" ? <LogoWhite /> : <LogoBlack />}
                    </a>
                    <div className="hage-header__actions">
                        <button
                            className="hage-header__menu-btn"
                            onClick={onMenuToggle}
                            aria-expanded={menuOpen}
                            aria-label={menuOpen ? "Lukk meny" : "Åpne meny"}
                        >
                            {menuOpen ? <CloseIcon /> : <HamburgerIcon />}
                            <span>{menuOpen ? "Lukk" : "Meny"}</span>
                        </button>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default HageHeader;
